import { axiosInstance, endpoints } from '../utils/axios';

interface UploadAsset {
  id?: string;
  type: string;
  file: File;
  shouldCheckSafety?: boolean;
}

interface AssetResponse {
  bucketPath: string;
  url: string;
}

export async function uploadAsset(payload: UploadAsset): Promise<AssetResponse> {
  const formData = new FormData();
  formData.append('file', payload.file);
  if (payload.id) {
    formData.append('id', payload.id);
  }
  formData.append('type', payload.type);
  formData.append('shouldCheckSafety', String(payload.shouldCheckSafety));

  try {
    const response = await axiosInstance.post<AssetResponse>(endpoints.assets.upload, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.message || 'Failed to upload asset');
  }
}

export async function deleteAsset(bucketPath: string): Promise<void> {
  return axiosInstance.delete(endpoints.assets.delete, {
    data: { bucketPath },
  });
}
